/* eslint-disable no-underscore-dangle */
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'react-app-polyfill/ie9';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { fromJS } from 'immutable';
import { createBrowserHistory as createHistory } from 'history';
import { syncHistoryWithStore } from 'react-router-redux';
import routes from './routes';
import Root from './Root';
import configureStore from './redux/configureStore';

import '../style/index.css';

let initialState = {};

// rehydrate initialState for JS app
if (window.__INITIAL_STATE__) {
  initialState = window.__INITIAL_STATE__;

  // Transform into Immutable.js collections,
  // but leave top level keys untouched for Redux
  Object
    .keys(initialState)
    .forEach((key) => {
      initialState[key] = fromJS(initialState[key]);
    });
}

const browserHistory = createHistory({ basename: '/' });

const store = configureStore(initialState, browserHistory);

const history = syncHistoryWithStore(browserHistory, store);

// Render the React application to the DOM
// Root component is to bootstrap Provider, Router and DevTools
ReactDOM.render(
  <Root history={history} routes={routes} store={store} />,
  document.getElementById('app-container'),
);



// WEBPACK FOOTER //
// ./src/js/router.jsx